import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/main.scss';

interface SuccessProps {
  onReset: () => void;
}

class Success extends React.Component<SuccessProps> {
  render() {
    return (
      <div className="success-container">
        <div className="success-circle">
          <span className="success-checkmark">✓</span>
        </div>
        <h2 className="success-title">નોંધણી સફળ!</h2>
        <p className="success-description">
          તમારી વીમા નોંધણી સફળતાપૂર્વક પૂર્ણ થઈ ગઈ છે.<br/>
          તમારું PDF ફોર્મ ડાઉનલોડ થઈ રહ્યું છે.
        </p>
        
        <div className="success-actions">
          <Link to="/" className="btn-white btn-secondary">
            હોમ પેજ
          </Link>
          <button onClick={this.props.onReset} className="form-btn">
            નવી નોંધણી
          </button>
        </div>
      </div>
    );
  }
}

export default Success;